import { cn } from '@/core/lib/utils';
import type { OptionItem } from '../types';

interface OptionBadgeProps {
  option: OptionItem;
  selected: boolean;
  onToggle: (id: string) => void;
}

export function OptionBadge({ option, selected, onToggle }: OptionBadgeProps) {
  return (
    <button
      type="button"
      data-testid={`onboarding-option-badge-${option.id}`}
      onClick={() => onToggle(option.id)}
      aria-pressed={selected}
      className={cn(
        'inline-flex items-center gap-2 px-4 py-2 rounded-lg border text-sm',
        'transition-all duration-150 cursor-pointer select-none',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50',
        selected
          ? 'border-primary bg-primary/10 text-primary font-medium'
          : 'border-border bg-background text-foreground hover:border-primary/50 hover:bg-muted',
      )}
    >
      {option.icon && <span className="flex items-center text-current">{option.icon}</span>}
      {option.label}
    </button>
  );
}
